"use client";

import Link from "next/link";

import { ThemeLogo } from "@/components/shared/theme-logo";
import { ThemeToggle } from "@/components/shared/theme-toggle";
import { useFocusMode } from "@/hooks/use-focus-mode";
import { APP_ROUTES } from "@/utils/constants";

import { DesktopNavigation } from "./layout-navigation-desktop";

export default function AppLayoutMenu() {
  const { focusedClassName } = useFocusMode();

  return (
    <div className={focusedClassName}>
      <div className="mb-8 flex items-center justify-between pt-6 pl-4">
        <Link href={APP_ROUTES.app} prefetch={false}>
          <ThemeLogo width={80} />
        </Link>
        <div className="mr-1">
          <ThemeToggle />
        </div>
      </div>
      <DesktopNavigation />
    </div>
  );
}
